import { Prompt } from "../components/PredefinedPrompts";

/**
 * @deprecated - Admin access is now controlled by isAdmin field from API
 * This function is kept for backward compatibility but should not be used
 * Use useUserAccess hook or getUserAccessLevel utility instead
 */
export const getAdminUserIds = (): number[] => {
  console.warn(
    "getAdminUserIds is deprecated. Use useUserAccess hook instead.",
  );
  return [];
};

/**
 * @deprecated - Admin access is now controlled by isAdmin field from API
 * This function is kept for backward compatibility but should not be used
 * Use useUserAccess hook instead
 */
export const isAdminUser = (userId: number | undefined): boolean => {
  console.warn("isAdminUser is deprecated. Use useUserAccess hook instead.");
  // Always return false - access control should only use API data via useUserAccess hook
  return false;
};

export const defaultSteps = [{ id: "st1", title: "Thinking" }];
export const prSteps = [
  {
    id: "pr1",
    title: "Retrieving historical press releases and your brand tone",
  },
  {
    id: "pr2",
    title: "Drafting the press release in chosen press style",
  },
  {
    id: "pr3",
    title: "Reviewing the draft for brand alignment and factual accuracy",
  },
  {
    id: "pr4",
    title: "Iterating between drafting and review",
  },
  {
    id: "pr5",
    title: "Finalizing the press release",
  },
];
export const localizerSteps = [
  { id: "a1", title: "Translating the press release" },
  { id: "a2", title: "Reviewing for cultural nuances" },
  { id: "a3", title: "Iterating between drafting and review" },
  { id: "a4", title: "Finalizing the press release" },
];
export const mediaBriefSteps = [
  { id: "b1", title: "Retrieving historical media brief and Q&A" },
  { id: "b2", title: "Drafting key questions" },
  { id: "b3", title: "Drafting executive responses" },
  { id: "b4", title: "Identifying responses which require human review" },
  { id: "b5", title: "Finalizing the media brief" },
];
export const socialMediaStepsWithImage = [
  { id: "c1", title: "Analyzing historical social media posts" },
  { id: "c2", title: "Initiating social media agent" },
  {
    id: "c3",
    title: "Reviewing the posts for tone alignment, structure, and compliance",
  },
  { id: "c4", title: "Iterating and generating the media scores" },
  { id: "c5", title: "Generating images for social media posts" },
  { id: "c6", title: "Finalizing the social media posts" },
];
export const socialMediaStepsWithoutImage = [
  { id: "c1", title: "Analyzing historical social media posts" },
  { id: "c2", title: "Initiating social media agent" },
  {
    id: "c3",
    title: "Reviewing the posts for tone alignment, structure, and compliance",
  },
  { id: "c4", title: "Iterating and generating the media scores" },
  { id: "c5", title: "Finalizing the social media posts" },
];

export const internalComSteps = [
  { id: "d1", title: "Retrieving past internal emails" },
  { id: "d2", title: "Drafting and incorporating internal communication tone" },
  { id: "d3", title: "Finalizing the executive email" },
];

export const syntheticResumeSteps = [
  { id: "sr1", title: "Mapping role to core functional and technical skills" },
  { id: "sr2", title: "Identifying future-ready skills" },
  { id: "sr3", title: "Establishing required qualification" },
  { id: "sr4", title: "Generating preferred qualification" },
  { id: "sr5", title: "Designing first-interview screening questions" },
];

export const rfqEvaluatorSteps = [
  { id: "rfe1", title: "Parsing evaluation framework and criteria" },
  { id: "rfe2", title: "Extracting vendor responses and RFQ requirements" },
  { id: "rfe3", title: "Normalizing criteria and weights" },
  { id: "rfe4", title: "Scoring vendors against evaluation criteria" },
  { id: "rfe5", title: "Generating vendor rankings and recommendations" },
  { id: "rfe6", title: "Preparing evaluation report" },
];

export const modifyRequirementsSteps = [
  { id: "mr1", title: "Updating the required changes as per your input" },
];

export const resumeFetcherSteps = [
  { id: "rf1", title: "Searching candidate database" },
  { id: "rf2", title: "Filtering candidates by qualifications" },
  { id: "rf3", title: "Retrieving candidate profiles" },
  { id: "rf4", title: "Finalizing candidate list" },
];

export const scoringSteps = [
  {
    id: "sc1",
    title: "Screening resumes on functional skills & preferred qualifications",
  },
  { id: "sc2", title: "Applying historical interview feedback, if available" },
  { id: "sc3", title: "Overlaying current role, title, location" },
  { id: "sc4", title: "Evaluation based on first round interview fit" },
];

export const emailDraftingSteps = [
  { id: "ed1", title: "Analyzing candidate profiles" },
  { id: "ed2", title: "Drafting personalized emails" },
  { id: "ed3", title: "Reviewing email content" },
  { id: "ed4", title: "Finalizing email drafts" },
];

export const sowAutoFillerSteps = [
  { id: "sow1", title: "Preparing contract workspace" },
  { id: "sow2", title: "Validating contract name" },
  { id: "sow3", title: "Setting up document structure" },
];

export const sowPreAnalyzerSteps = [
  { id: "spa1", title: "Analyzing proposal document" },
  { id: "spa2", title: "Detecting business unit and category" },
  { id: "spa3", title: "Identifying contract type" },
  { id: "spa4", title: "Searching for matching template" },
];

export const sowDataModifierSteps = [
  { id: "sdm1", title: "Processing modification requests" },
  { id: "sdm2", title: "Validating changes" },
  { id: "sdm3", title: "Updating SOW fields" },
  { id: "sdm4", title: "Regenerating document" },
];

export const sowQuestionAnswererSteps = [
  { id: "sqa1", title: "Understanding your question" },
  { id: "sqa2", title: "Searching document context" },
  { id: "sqa3", title: "Preparing detailed answer" },
];

export const sowFinalGeneratorSteps = [
  { id: "sfg1", title: "Finalizing SOW content" },
  { id: "sfg2", title: "Generating DOCX document" },
  { id: "sfg3", title: "Validating output" },
  { id: "sfg4", title: "Preparing download" },
];

export const translationAgentSteps = [
  {
    id: "l1",
    title: "Identifying the source and target language",
  },
  { id: "l2", title: "Understanding the content type" },
  { id: "l3", title: "Translating with appropriate tone and terminology" },
  { id: "l4", title: "Reviewing for accuracy, clarity, and consistency" },
  { id: "l5", title: "Delivering the finalized content" },
];

export const jdComposerSteps = [
  { id: "jdc1", title: "Analyzing role requirements and job description" },
  { id: "jdc2", title: "Composing job overview and responsibilities" },
  { id: "jdc3", title: "Mapping core functional and technical skills" },
  { id: "jdc4", title: "Identifying future-ready skills" },
  { id: "jdc5", title: "Establishing required and preferred qualifications" },
];

export const checklistAgentSteps = [
  { id: "cl1", title: "Generating business & commercial checklist" },
  { id: "cl2", title: "Generating financial & payment checklist" },
  { id: "cl3", title: "Generating procurement & vendor governance checklist" },
  {
    id: "cl4",
    title: "Generating legal, security & regulatory compliance checklist",
  },
];

export const TemplateReviewerAgentSteps = [
  { id: "cl1", title: "Reviewing against business checklist" },
  { id: "cl2", title: "Reviewing against finance checklist" },
  { id: "cl3", title: "Reviewing against procurement checklist" },
  { id: "cl4", title: "Reviewing against legal checklist" },
  { id: "cl5", title: "Creating summary" },
  { id: "cl6", title: "Generating output & recommendation" },
];

export const ContractReviewerQAAgentSteps = [
  { id: "crqa1", title: "Understanding your question" },
  { id: "crqa2", title: "Searching contract review data" },
  { id: "crqa3", title: "Preparing detailed answer" },
];

export const ContractReviewerAgentSteps = [
  { id: "cr1", title: "Initiating business review" },
  { id: "cr2", title: "Initiating finance review" },
  { id: "cr3", title: "Initiating procurement review" },
  { id: "cr4", title: "Initiating legal review" },
  { id: "cr5", title: "Analysing deviations, key gaps & risks" },
  { id: "cr6", title: "Generating negotiation points" },
];

export const ConsolidatorAgentSteps = [
  { id: "cn1", title: "Consolidator agent initiated" },
  { id: "cn2", title: "Consolidating negotiation playbook across functions" },
  { id: "cn3", title: "Generating negotiation themes & bundling suggestions" },
];

export const ConsolidatorAgentSupplierCommSteps = [
  { id: "cs1", title: "Analysing consolidated summary" },
  { id: "cs2", title: "Generating supplier communication" },
];

export const RedraftingAgentSteps = [
  { id: "rd1", title: "Analyzing negotiation playbook" },
  { id: "rd2", title: "Analyzing contract document" },
];

export const LegalReviewerAgentSteps = [
  { id: "lr1", title: "Initiating legal review" },
  { id: "lr2", title: "Analyzing legal clauses and terms" },
  { id: "lr3", title: "Checking regulatory compliance" },
  { id: "lr4", title: "Identifying legal risks and gaps" },
  { id: "lr5", title: "Generating legal recommendations" },
];

export const TemplateGuidedIntakeAgentSteps = [
  { id: "ti1", title: "Gathering business context and contract type" },
  { id: "ti2", title: "Collecting use case specific requirements" },
  { id: "ti3", title: "Capturing contract terms and conditions" },
];

export const TemplateDocumentSelectorSteps = [
  { id: "ts1", title: "Identifying business unit and template options" },
];

export const TemplateDrafterSteps = [
  { id: "td1", title: "Processing collected contract details" },
  { id: "td2", title: "Populating template with your inputs" },
  { id: "td3", title: "Generating filled contract template" },
  { id: "td4", title: "Creating contract summary PDF" },
];

export const TemplateReviewerQASteps = [
  { id: "tq1", title: "Processing your modification requests" },
  { id: "tq2", title: "Updating contract template fields" },
  { id: "tq3", title: "Regenerating updated contract PDF" },
];

export const TemplateRequestOrchestratorSteps = [
  { id: "to1", title: "Understanding your procurement need" },
  { id: "to2", title: "Selecting best practice template" },
  { id: "to3", title: "Collecting contract requirements" },
  { id: "to4", title: "Gathering use case details" },
  { id: "to5", title: "Capturing contract terms" },
  { id: "to6", title: "Generating filled template" },
  { id: "to7", title: "Creating contract summary PDF" },
];

export const RoleValidationAgentSteps = [
  { id: "jdc1", title: "Validating role" },
];

export const SowDocumentAnalyzerSteps = [
  { id: "sda0", title: "Analysing proposal document" },
  { id: "sda1", title: "Analysing SOW template sections" },
  { id: "sda2", title: "Generating required details" },
  { id: "sda3", title: "Checking for best practices" },
  { id: "sda4", title: "Drafting SOW document" },
];

export const NdaOrchestratorSteps = [
  { id: "nda0", title: "Initialising G42 NDA workflow..." },
];

export const NdaIntakeSteps = [
  { id: "ndai1", title: "Analysing your NDA requirements..." },
  { id: "ndai2", title: "Preparing intake summary for your review..." },
];

export const NdaCounterpartySteps = [
  { id: "ndac1", title: "Verifying counterparty details..." },
];

export const NdaConflictSteps = [
  { id: "ndacf1", title: "Running conflict checks..." },
];

export const NdaTemplateSteps = [
  { id: "ndat1", title: "Identifying the best-fit NDA template..." },
];

export const NdaPartyDetailsSteps = [
  { id: "ndap1", title: "Gathering party information for the draft..." },
];

export const NdaDraftingSteps = [
  { id: "ndad1", title: "Retrieving G42 standard NDA template..." },
  { id: "ndad2", title: "Populating clauses, parties and jurisdiction..." },
  { id: "ndad3", title: "Finalising your NDA draft..." },
];

export const NdaValidationSteps = [
  { id: "ndav1", title: "Running G42 policy compliance checks..." },
  { id: "ndav2", title: "Comparing against G42 standard NDA language..." },
  { id: "ndav3", title: "Identifying deviations and risk items..." },
];

export const NdaReviewSteps = [
  { id: "ndar1", title: "Parsing uploaded NDA document..." },
  { id: "ndar2", title: "Extracting clauses, parties and key dates..." },
  { id: "ndar3", title: "Assessing risk levels against G42 standards..." },
  { id: "ndar4", title: "Generating detailed review report..." },
];

export const NdaQASteps = [
  { id: "ndaq1", title: "Answering your question about the NDA..." },
];

// ── MoU Agent progress steps ──
// export const MouOrchestratorSteps = [
//   { id: "mou0", title: "Initialising MoU workflow" },
// ];

export const MouIntakeSteps = [
  { id: "moui1", title: "Analysing your MoU requirements" },
  { id: "moui2", title: "Preparing intake questions" },
];

export const MouExtractionSteps = [
  { id: "moue1", title: "Extracting structured fields from your input" },
  { id: "moue2", title: "Classifying MoU template type" },
];

export const MouConfirmationSteps = [
  { id: "mouc1", title: "Preparing confirmation details for review" },
];

export const MouDraftingSteps = [
  { id: "moud1", title: "Retrieving G42 standard MoU template" },
  { id: "moud2", title: "Populating articles, parties and jurisdiction" },
  { id: "moud3", title: "Generating signature blocks" },
  { id: "moud4", title: "Finalising your MoU draft" },
];

export const MouCompletionSteps = [
  { id: "moucp1", title: "Building DOCX document" },
  { id: "moucp2", title: "Uploading to secure storage" },
];

export const SkillIntelligenceSteps = [
  { id: "hc1", title: "Extract and summarize JD content" },
  { id: "hc2", title: "Identify role and role type" },
  { id: "hc3", title: "Get benchmark skill count from framework" },
  {
    id: "hc4",
    title: "Map closest matching taxonomy skills",
  },
  {
    id: "hc5",
    title: "Review and refine benchmark mappings through AI recommendations",
  },
  { id: "hc6", title: "Generate final skill and proficiency benchmark output" },
];

export const WORKFLOW_SEQUENCE = [
  "default",
  "pr",
  "localizer",
  "mediaBrief",
  "socialMedia",
  "internalCom",
];

// Helper function to get appropriate social media steps based on image generation flag
export const getSocialMediaSteps = (isImageGeneration?: boolean): any[] => {
  return isImageGeneration
    ? socialMediaStepsWithImage
    : socialMediaStepsWithoutImage;
};

export const socialMediaSteps = socialMediaStepsWithImage; // Default to with image for backward compatibility

// ── CV Screener agent progress steps ──
export const cvScreenerRouterSteps = [
  { id: "cvr1", title: "Understanding your request" },
  { id: "cvr2", title: "Getting things ready" },
];

export const cvScreenerJdMatcherSteps = [
  { id: "cvjm1", title: "Looking up job descriptions" },
  { id: "cvjm2", title: "Finding the best match" },
  { id: "cvjm3", title: "Loading job description details" },
];

export const cvScreenerJdCustomizerSteps = [
  { id: "cvjc1", title: "Reviewing your requirements" },
  { id: "cvjc2", title: "Updating the job description" },
  { id: "cvjc3", title: "Finalizing changes" },
];

export const cvScreenerCvParserSteps = [
  { id: "cvp1", title: "Reading the resume" },
  { id: "cvp2", title: "Identifying candidate details" },
  { id: "cvp3", title: "Organizing skills & experience" },
];

export const cvScreenerScorerSteps = [
  { id: "cvs1", title: "Comparing resume to job requirements" },
  { id: "cvs2", title: "Evaluating candidate fit" },
  { id: "cvs3", title: "Calculating overall score" },
  { id: "cvs4", title: "Preparing assessment report" },
];

export const cvScreenerExplainerSteps = [
  { id: "cve1", title: "Reviewing the assessment" },
  { id: "cve2", title: "Writing detailed feedback" },
];

export const cvScreenerIntakeSteps = [
  { id: "cvi1", title: "Reviewing your submission" },
];

export const talkWithDataSteps = [
  { id: "qp1", title: "Understanding user query" },
  { id: "qp2", title: "Identifying relevant database tables" },
  { id: "qp3", title: "Drafting SQL query" },
  { id: "qp4", title: "Fetching results" },
  { id: "qp5", title: "Processing output" },
];

export const RFQEvaluatorSteps = [
  { id: "rfe1", title: "Parsing evaluation framework and criteria" },
  { id: "rfe2", title: "Extracting vendor responses and RFQ requirements" },
  { id: "rfe3", title: "Normalizing criteria and weights" },
  { id: "rfe4", title: "Scoring vendors against evaluation criteria" },
];

export const RFQDocumentProcessingSteps = [
  { id: "rfqp1", title: "Normalizing inputs" },
  { id: "rfqp2", title: "Classifying content" },
  { id: "rfqp3", title: "Extracting key data" },
  { id: "rfqp4", title: "Mapping to criteria" },
  { id: "rfqp5", title: "Aggregating insights" },
  { id: "rfqp6", title: "Processing complete" },
];
export const CocReviewDocumentAnalyzer = [
  { id: "cocda1", title: "Preparing documentation for review and analysis" },
  { id: "cocda2", title: "Extracting relevant textual data" },
  { id: "cocda3", title: "Structuring and organizing document information" },
  { id: "cocda4", title: "Evaluating applicable trigger conditions" },
  { id: "cocda5", title: "Delivering summarized insights" },
];

export const stepSequence = [
  prSteps,
  localizerSteps,
  mediaBriefSteps,
  socialMediaSteps,
  internalComSteps,
];

// Map agent IDs to their step groups
export const getStepsByAgentId = (
  agentId?: string,
  isImageGeneration?: boolean,
): any[] => {
  if (!agentId) return [];

  switch (agentId) {
    case "press_release_agent":
    case "PressReleaseAgent":
      return prSteps;
    case "LocalizerAgent":
    case "localizer_agent":
      return localizerSteps;
    case "media_brief_agent":
    case "MediaBriefAgent":
      return mediaBriefSteps;
    case "social_media_insights_agent":
    case "LinkedinAgent":
    case "SocialMediaInsightsAgent":
      return getSocialMediaSteps(isImageGeneration);
    case "internal_communication_agent":
    case "InternalCommunicationAgent":
      return internalComSteps;
    case "role_validation_failed":
      return RoleValidationAgentSteps;
    case "synthetic_resume_agent":
      return syntheticResumeSteps;
    case "resume_fetcher_agent":
      return resumeFetcherSteps;
    case "scoring_agent":
    case "scoring_agent_new":
      return scoringSteps;
    case "email_drafting":
      return emailDraftingSteps;
    case "modify_requirements":
      return modifyRequirementsSteps;
    case "translation_agent":
      return translationAgentSteps;
    case "contract_reviewer_qa_agent":
      return ContractReviewerQAAgentSteps;
    case "template_reviewer_checklist_agent":
      return checklistAgentSteps;
    case "template_reviewer_agent":
      return TemplateReviewerAgentSteps;
    case "template_guided_intake_agent":
      return TemplateGuidedIntakeAgentSteps;
    case "template_document_selector_agent":
      return TemplateDocumentSelectorSteps;
    case "template_drafter_agent":
      return TemplateDrafterSteps;
    case "template_reviewer_qa_agent":
      return TemplateReviewerQASteps;
    case "template_request_orchestrator":
      return []; // Don't show steps - sub-agents will show their own
    case "contract_reviewer_orchestrator":
      return ContractReviewerAgentSteps;
    case "legal_reviewer_orchestrator":
      return []; // Don't show steps - sub-agents will show their own
    case "consolidator_agent":
      return ConsolidatorAgentSteps;
    case "consolidator_agent_supplier_comm":
      return ConsolidatorAgentSupplierCommSteps;
    case "redrafting_agent":
      return RedraftingAgentSteps;
    case "sow_document_analyzer":
      return SowDocumentAnalyzerSteps;
    case "sow_pre_analyzer":
      return sowPreAnalyzerSteps;
    case "sow_data_modifier":
      return sowDataModifierSteps;
    case "sow_question_answerer":
      return sowQuestionAnswererSteps;
    case "sow_auto_filler":
      return sowAutoFillerSteps;
    case "sow_final_generator":
      return sowFinalGeneratorSteps;
    // case "synthetic_resume_agent":
    case "jd_composer_agent":
    case "skill_inference_agent":
      return jdComposerSteps;
    // CV Screener agents
    case "router_agent":
      return cvScreenerRouterSteps;
    case "jd_matcher_agent":
      return cvScreenerJdMatcherSteps;
    case "jd_customizer_agent":
      return cvScreenerJdCustomizerSteps;
    case "cv_parser_agent":
      return cvScreenerCvParserSteps;
    case "scorer_agent":
      return cvScreenerScorerSteps;
    case "explainer_agent":
      return cvScreenerExplainerSteps;
    case "intake_agent":
      return cvScreenerIntakeSteps;
    case "answer_composer_agent":
      return talkWithDataSteps;
    // NDA agents
    case "nda_orchestrator":
      return NdaOrchestratorSteps;
    case "nda_intake_agent":
      return NdaIntakeSteps;
    case "nda_counterparty_agent":
      return NdaCounterpartySteps;
    case "nda_conflict_agent":
      return NdaConflictSteps;
    case "nda_template_selector_agent":
      return NdaTemplateSteps;
    case "nda_draft_field_capture_agent":
      return NdaPartyDetailsSteps;
    case "nda_drafting_agent":
      return NdaDraftingSteps;
    case "nda_validation_agent":
      return NdaValidationSteps;
    case "nda_reviewer_agent":
    case "nda_parser_agent":
      return NdaReviewSteps;
    case "nda_qa_agent":
      return NdaQASteps;
    // MoU agents
    // case "mou_orchestrator":
    // case "memorandum-of-understanding":
    //   return MouOrchestratorSteps;
    case "mou_intake_agent":
      return MouIntakeSteps;
    case "mou_extraction_agent":
      return MouExtractionSteps;
    case "mou_confirmation_agent":
      return MouConfirmationSteps;
    case "mou_drafting_agent":
      return MouDraftingSteps;
    case "mou_completion_agent":
      return MouCompletionSteps;
    case "document_processor":
      return RFQDocumentProcessingSteps;
    case "coc_document_processor":
      return CocReviewDocumentAnalyzer;

    // Human capital skill intelligence
    case "skill_mapping_agent":
      return SkillIntelligenceSteps;
    default:
      return [];
  }
};

export const getAgentStartedSteps = (
  agentId?: string,
  isImageGeneration?: boolean,
): any[] => {
  if (!agentId) return [];

  switch (agentId) {
    case "press_release_started":
      return prSteps;
    case "localizer_started":
      return localizerSteps;
    case "media_brief_started":
      return mediaBriefSteps;
    case "social_media_started":
      return getSocialMediaSteps(isImageGeneration);
    case "internal_communication_started":
      return internalComSteps;
    case "role_validation_failed":
      return RoleValidationAgentSteps;
    case "contract_reviewer_qa_agent":
      return ContractReviewerQAAgentSteps;
    case "synthetic_resume_agent":
      return syntheticResumeSteps; // Don't show steps during validation phase
    case "resume_fetcher_agent":
      return resumeFetcherSteps;
    case "scoring_agent":
    case "scoring_agent_new":
      return scoringSteps;
    case "email_drafting":
      return emailDraftingSteps;
    case "modify_requirements":
      return modifyRequirementsSteps;
    case "translation_started":
      return translationAgentSteps;
    case "template_reviewer_checklist_agent":
      return []; // Don't show steps for checklist agent - it's an internal step
    case "template_reviewer_started":
      return TemplateReviewerAgentSteps;
    case "template_reviewer_agent":
      return []; // Steps already shown by template_reviewer_started
    case "template_guided_intake_agent":
    case "template_guided_intake_started":
      return TemplateGuidedIntakeAgentSteps;
    case "template_document_selector_agent":
    case "template_document_selector_started":
      return TemplateDocumentSelectorSteps;
    case "template_drafter_agent":
    case "template_drafter_started":
      return TemplateDrafterSteps;
    case "template_reviewer_qa_agent":
    case "template_reviewer_qa_started":
      return TemplateReviewerQASteps;
    case "template_request_orchestrator":
    case "template_request_started":
      return []; // Don't show steps - sub-agents will show their own
    case "jd_composer_agent":
    case "skill_inference_agent":
      return jdComposerSteps;
    case "business_reviewer_started":
    case "BusinessReviewerAgent":
      return [
        ContractReviewerAgentSteps[0],
        ContractReviewerAgentSteps[4],
        ContractReviewerAgentSteps[5],
      ]; // Step 1: Business review, Step 5: Deviation analysis, Step 6: Negotiation points
    case "finance_reviewer_started":
      return [ContractReviewerAgentSteps[1]]; // Step 2: Finance review
    case "procurement_reviewer_started":
      return [ContractReviewerAgentSteps[2]]; // Step 3: Procurement review
    case "legal_reviewer_started":
      return [ContractReviewerAgentSteps[3]]; // Step 4: Legal review
    case "deviation_analysis_started":
    case "DeviationAnalysisAgent":
    case "DeviationAnalyzer":
    case "RFPDeviationAnalyzer":
    case "deviation_analyzer":
    case "rfp_deviation_analyzer":
    case "analyze_deviations":
      return [ContractReviewerAgentSteps[4]]; // Step 5: Deviation analysis
    case "negotiation_points_started":
    case "NegotiationPointsAgent":
    case "NegotiationPointsGenerator":
    case "negotiation_points_generator":
    case "generate_negotiation_points":
    case "legal_reviewer_orchestrator_started":
      return [];
    case "negotiation_generator":
      return [ContractReviewerAgentSteps[5]]; // Step 6: Negotiation points
    case "contract_reviewer_orchestrator_started":
      return []; // Don't show steps for orchestrator start
    case "consolidator_started":
      return ConsolidatorAgentSteps;
    case "consolidator_agent":
      return []; // Steps already shown by consolidator_started
    case "consolidator_agent_supplier_comm":
    case "consolidator_supplier_comm_started":
      return ConsolidatorAgentSupplierCommSteps;
    case "redrafting_agent":
    case "redrafting_started":
      return RedraftingAgentSteps;
    case "sow_document_analyzer":
      return SowDocumentAnalyzerSteps;
    case "sow_pre_analyzer":
      return sowPreAnalyzerSteps;
    case "sow_data_modifier":
      return sowDataModifierSteps;
    case "sow_question_answerer":
      return sowQuestionAnswererSteps;
    case "sow_auto_filler_started":
      return sowAutoFillerSteps;
    case "sow_final_generator":
      return sowFinalGeneratorSteps;
    case "query_planner_agent":
      return talkWithDataSteps;

    // CV Screener agents
    case "router_agent":
      return cvScreenerRouterSteps;
    case "jd_matcher_agent":
      return cvScreenerJdMatcherSteps;
    case "jd_customizer_agent":
      return cvScreenerJdCustomizerSteps;
    case "cv_parser_agent":
      return cvScreenerCvParserSteps;
    case "scorer_agent":
      return cvScreenerScorerSteps;
    case "explainer_agent":
      return cvScreenerExplainerSteps;
    case "intake_agent":
      return cvScreenerIntakeSteps;

    // NDA agents
    case "nda_orchestrator_started":
    case "nda_orchestrator":
      return NdaOrchestratorSteps;
    case "nda_intake_started":
    case "nda_intake_agent":
      return NdaIntakeSteps;
    case "nda_counterparty_started":
    case "nda_counterparty_agent":
      return NdaCounterpartySteps;
    case "nda_conflict_started":
    case "nda_conflict_agent":
      return NdaConflictSteps;
    case "nda_template_started":
    case "nda_template_selector_agent":
      return NdaTemplateSteps;
    case "nda_draft_field_capture_agent":
      return NdaPartyDetailsSteps;
    case "nda_drafting_started":
    case "nda_drafting_agent":
      return NdaDraftingSteps;
    case "nda_validation_started":
    case "nda_validation_agent":
      return NdaValidationSteps;
    case "nda_review_started":
    case "nda_reviewer_agent":
    case "nda_parser_agent":
      return NdaReviewSteps;
    case "nda_qa_agent":
      return NdaQASteps;
    case "nda_review_pipeline":
      return NdaReviewSteps;

    // MoU agents
    case "mou_orchestrator_started":
    // case "mou_orchestrator":
    // case "memorandum-of-understanding":
    //   return MouOrchestratorSteps;
    case "mou_intake_started":
    case "mou_intake_agent":
      return MouIntakeSteps;
    case "mou_extraction_started":
    case "mou_extraction_agent":
      return MouExtractionSteps;
    case "mou_confirmation_started":
    case "mou_confirmation_agent":
      return MouConfirmationSteps;
    case "mou_drafting_started":
    case "mou_drafting_agent":
      return MouDraftingSteps;
    case "mou_completion_started":
    case "mou_completion_agent":
      return MouCompletionSteps;

    // RFQ Evaluator agents
    case "document_processor":
      return RFQDocumentProcessingSteps;

    // Coc Review
    case "coc_document_processor":
      return CocReviewDocumentAnalyzer;

    // Human capital skill intelligence
    case "skill_mapping_executor":
      return SkillIntelligenceSteps;

    default:
      return [];
  }
};

export const defaultMarketingPrompts: Prompt[] = [
  {
    title: "Product Launch & Update",
    prompt:
      "Create a multi-channel marketing campaign for product launch or update",
  },
  {
    title: "Partnership Announcement",
    prompt:
      "Create a multi-channel marketing campaign for strategic partnership announcement",
  },
  {
    title: "Leadership Announcement",
    prompt:
      "Create a multi-channel marketing campaign for leadership or executive appointment announcement",
  },
  {
    title: "Strategic Announcement",
    prompt:
      "Create a multi-channel marketing campaign for strategic vision announcement",
  },
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

// Agent-specific file size limits (in bytes)
// Agents not listed here will use MAX_FILE_SIZE as default
export const AGENT_FILE_SIZE_LIMITS: Record<number, number> = {
  20: Number.MAX_SAFE_INTEGER, // No limit for Contract Review and Finalization Agent (ID 20)
  44: 200 * 1024 * 1024, // 200 MB for RFQ Evaluator Agent (ID 44)
};

/**
 * Get the maximum file size limit for a specific agent
 * @param agentId - The agent ID
 * @returns The file size limit in bytes
 */
export const getMaxFileSizeForAgent = (agentId: number | undefined): number => {
  if (!agentId) return MAX_FILE_SIZE;
  return AGENT_FILE_SIZE_LIMITS[agentId] ?? MAX_FILE_SIZE;
};

// Agent IDs that support file attachment functionality
export const AGENTS_WITH_FILE_ATTACHMENT = [
  11, 7, 20, 18, 21, 45, 46, 44, 47, 30, 106, 48, 110, 103, 54, 59, 60, 504,
];

// Agent IDs that should navigate directly to their route without /chat prefix
// These agents have their own dedicated routes (e.g., /agent-name instead of /chat/agent-name)
export const AGENTS_WITHOUT_CHAT_PREFIX: number[] = [
  // Add agent IDs here that should skip /chat prefix
  // Example: 100, 101, 102
  104,
  138, // Interview Host Agent - uses /agent/interview_host_agent route
];

/**
 * Helper function to construct agent navigation URL
 * @param agentId - The agent ID (number)
 * @param urlIdentifier - The agent's framework_name or numeric ID
 * @param sessionId - Optional session ID to append as query parameter
 * @returns The complete navigation URL with or without /chat prefix
 */
export const getAgentNavigationUrl = (
  agentId: number,
  urlIdentifier: string | number,
  sessionId?: string | null,
): string => {
  const baseUrl = AGENTS_WITHOUT_CHAT_PREFIX.includes(agentId)
    ? `/agent/${urlIdentifier}`
    : `/chat/${urlIdentifier}`;

  const finalUrl = sessionId ? `${baseUrl}?sessionId=${sessionId}` : baseUrl;

  // Debug logging
  console.log(
    `getAgentNavigationUrl - agentId: ${agentId}, urlIdentifier: ${urlIdentifier}, finalUrl: ${finalUrl}`,
  );

  return finalUrl;
};

/**
 * Helper function to append bearer token to external agent URLs
 * @param url - The external agent endpoint URL
 * @param token - The MSAL access token to append
 * @returns The URL with token appended as query parameter
 */
export const appendTokenToUrl = (url: string, token: string): string => {
  if (!url) return url;

  if (!token) {
    console.warn("No access token provided for external agent URL");
    return url;
  }

  try {
    const urlObj = new URL(url);
    urlObj.searchParams.set("token", token);
    return urlObj.toString();
  } catch (error) {
    console.error("Invalid URL format:", url, error);
    return url;
  }
};

// Agent IDs that should keep HR filters visible even after response
export const AGENTS_WITH_PERSISTENT_HR_FILTERS = [
  "no_candidates_found",
  "validation_check",
];

// Agents with end-flow behavior - inputs should be disabled after agent responds
// Once these agents provide their response, the workflow is complete and no further input is needed
// Maps agent ID (number) to agent name (string) for efficient lookup
export const AGENTS_WITH_END_FLOW: Record<number, string> = {
  52: "redline", // RedlineAgent - Document redlining and comparison
  55: "skill_mapping_agent_download", // HumanCapitalAgent - Skills mapping download (final step)
  57: "learning_path_utility_agent_form", // Learning path agent
  59: "talent_report_agent",
  54: "mou_orchestrator",
  504: "manpower_cost_calculator", // Manpower Cost Calculator - Cost estimation workflow
};

// Filter options for HR Agent
export const EXPERIENCE_OPTIONS = [
  { label: "0-3 years", value: "0-3" },
  { label: "3-10 years", value: "3-10" },
  { label: "10+ years", value: "10+" },
];

export const LOCATION_OPTIONS = [
  { label: "UAE", value: "uae" },
  { label: "Australia", value: "australia" },
  { label: "Bangladesh", value: "bangladesh" },
  { label: "Brazil", value: "brazil" },
  { label: "Canada", value: "canada" },
  { label: "Egypt", value: "egypt" },
  { label: "France", value: "france" },
  { label: "Germany", value: "germany" },
  { label: "India", value: "india" },
  { label: "Italy", value: "italy" },
  { label: "Jordan", value: "jordan" },
  { label: "Lebanon", value: "lebanon" },
  { label: "Malaysia", value: "malaysia" },
  { label: "Nigeria", value: "nigeria" },
  { label: "Philippines", value: "philippines" },
  { label: "Pakistan", value: "pakistan" },
  { label: "South Africa", value: "southafrica" },
  { label: "Sri Lanka", value: "srilanka" },
  { label: "Turkey", value: "turkey" },
  { label: "United Kingdom", value: "unitedkingdom" },
  { label: "United States", value: "unitedstates" },
  { label: "Others", value: "others" },
];

export const DEGREE_OPTIONS = [
  {
    label: "Bachelor’s in Computer Science / Data Science",
    value: "bachelorsincomputersciencedatascience",
  },
  {
    label: "Bachelor’s in Business Administration",
    value: "bachelorsinbusinessadministration",
  },
  {
    label: "Bachelor’s in Engineering",
    value: "bachelorsinengineering",
  },
  {
    label: "Bachelor’s in Finance / Economics",
    value: "bachelorsinfinanceeconomics",
  },
  {
    label: "Bachelor’s in Marketing",
    value: "bachelorsinmarketing",
  },
  {
    label: "Bachelor’s in Healthcare-related fields",
    value: "bachelorsinhealthcarerelatedfields",
  },
  {
    label: "Bachelor’s in Hospitality",
    value: "bachelorsinhospitality",
  },
  {
    label: "Bachelor’s in Law",
    value: "bachelorsinlaw",
  },
  {
    label: "Master’s in Computer Science / Data Science",
    value: "mastersincomputersciencedatascience",
  },
  {
    label: "Master’s in Business Administration (MBA)",
    value: "mastersinbusinessadministrationmba",
  },
  { label: "Master’s Degree", value: "mastersdegree" },
  { label: "PhD", value: "phd" },
  { label: "Others", value: "others" },
];

export const PREVIOUS_COMPANY_OPTIONS = [
  { label: "G42 Companies", value: "g42companies" },
  { label: "Abu Dhabi Companies", value: "abudhabicompanies" },
  { label: "Accenture", value: "accenture" },
  { label: "Bain & Company", value: "baincompany" },
  {
    label: "Boston Consulting Group (BCG)",
    value: "bostonconsultinggroupbcg",
  },
  { label: "Cisco", value: "cisco" },
  { label: "Citibank", value: "citibank" },
  { label: "Deloitte", value: "deloitte" },
  { label: "EY (Ernst & Young)", value: "eyernstyoung)" },
  { label: "Google", value: "google" },
  { label: "HSBC", value: "hsbc" },
  { label: "IBM", value: "ibm" },
  { label: "J.P. Morgan", value: "jpmorgan" },
  { label: "KPMG", value: "kpmg" },
  { label: "McKinsey & Company", value: "mckinseycompany" },
  { label: "Microsoft", value: "microsoft" },
  { label: "Oracle", value: "oracle" },
  { label: "Procter & Gamble (P&G)", value: "proctergamblepg" },
  { label: "PwC", value: "pwc" },
  { label: "Schlumberger", value: "schlumberger" },
  { label: "Siemens", value: "siemens" },
  { label: "Standard Chartered", value: "standardchartered" },
  { label: "Others", value: "others" },
];

export const PROCUREMENT_TYPE_OPTIONS = [
  {
    label: "Contract Request (SOW Creator) Agent",
    value: "sow_filler",
    placeholder:
      "What do you want the contract template to be for? (e.g., a cloud-based CRM for Core42)",
  },
  {
    label: "Contract Proposal Review Agent",
    value: "reviewer",
    placeholder:
      "I will perform a business, procurement, finance, and legal review of your contract proposal. Please upload the document.",
  },
  {
    label: "Final Contract Redraft Agent",
    value: "redraft",
    placeholder: "Upload negotiation list and contract proposal",
  },
];

export const CONTRACT_TYPE_OPTIONS = [
  { label: "Employment Contracts", value: "employment" },
  { label: "Purchase Agreements", value: "purchase" },
  { label: "Lease Agreements", value: "lease" },
  { label: "Service Agreements", value: "service" },
];

export const GROUP_COMPANY_OPTIONS = [
  { label: "Group 42 Holding Ltd", value: "group42holding" },
  { label: "Core42", value: "core42" },
  { label: "Inception", value: "inception" },
  { label: "Injazat", value: "injazat" },
  { label: "Khazna Data Centers", value: "khazna" },
  { label: "M42", value: "m42" },
  { label: "Presight AI Holding PLC", value: "presight" },
  { label: "CPX", value: "cpx" },
  { label: "Space42", value: "space42" },
  { label: "AIQ", value: "aiq" },
];

// Agent-specific text configuration
export interface AgentTextConfig {
  subtitle: string;
  promptTitle: string;
  inputPlaceholder: string;
}

export const AGENT_TEXT_CONFIG: Record<string, AgentTextConfig> = {
  "11": {
    subtitle: "Your intelligent marketing assistant that produces:",
    promptTitle: "What type of announcement would you like to make today?",
    inputPlaceholder:
      "Start with your prompt— the agent will gather any details needed for quality output, as needed ...",
  },
  "18": {
    subtitle:
      "Your intelligent recruiter agent that helps you efficiently reconnect with qualified previous candidates for new roles.",
    promptTitle: "What role are you trying to fill today?",
    inputPlaceholder: `Enter the job title and select the minimum qualification from the filters. You can upload new resumes or search G42 resume database.`,
  },
  "30": {
    subtitle:
      "Your intelligent recruiter agent that helps you efficiently evaluate AI agent profiles for all roles.",
    promptTitle: "What role are you trying to fill today?",
    inputPlaceholder: `Please enter the job title and upload agent profile to start`,
  },
  "7": {
    subtitle:
      "Your intelligent agent for translating general and legal documents.",
    promptTitle: "What type of translation you would like to do today?",
    inputPlaceholder:
      "Upload your document or enter your text here for translation",
  },
  "106": {
    subtitle:
      "Your intelligent agent for generating social media posts for X, Instagram and LinkedIn.",
    promptTitle: "What would you like to share on social media today?",
    inputPlaceholder: "Type your message here...",
  },
  "20": {
    subtitle:
      "Your intelligent agent for reviewing contract proposals and redrafting",
    promptTitle:
      "You can either upload an MSA/SOW for review against the standard MSA, or upload two versions of an MSA for comparison and review",
    inputPlaceholder:
      "I will perform a business, procurement, finance, and legal review of your contract proposal. Please upload the document.",
  },
  "21": {
    subtitle: "Your intelligent agent for generating SOW documents",
    promptTitle: "",
    inputPlaceholder: "Please upload the proposal document",
  },
  "46": {
    subtitle: "Your intelligent agent for reviewing contract templates",
    promptTitle: "",
    inputPlaceholder: "Please upload the contract template to start reviewing",
  },
  "23": {
    subtitle:
      "Your intelligent agent for composing comprehensive job descriptions with required skills and qualifications.",
    promptTitle: "Which job description you want to generate?",
    inputPlaceholder:
      "Enter the job title or role description to compose a complete job description...",
  },
  "24": {
    subtitle:
      "Your intelligent agent for inferring required skills and qualifications from job roles.",
    promptTitle: "Which job role would you like to analyze?",
    inputPlaceholder:
      "Enter the job title or role to infer required skills and qualifications...",
  },
  "25": {
    subtitle:
      "Your intelligent executive assistant for CEO's office operations.",
    promptTitle: "How can I assist you today?",
    inputPlaceholder: "Type your message here...",
  },
  "31": {
    subtitle: "Your intelligent assistant for smart meeting briefs.",
    promptTitle: "How can I assist you today?",
    inputPlaceholder: "Type your message here...",
  },
  "32": {
    subtitle: "Your intelligent assistant for news and tech trend watch.",
    promptTitle: "How can I assist you today?",
    inputPlaceholder: "Type your message here...",
  },
  "33": {
    subtitle: "Your intelligent assistant for workflow operation.",
    promptTitle: "How can I assist you today?",
    inputPlaceholder: "Type your message here...",
  },
  "1": {
    subtitle:
      "Your intelligent press release and marketing assistant that produces:",
    promptTitle: "What type of announcement would you like to make today?",
    inputPlaceholder:
      "Start with your prompt— the agent will gather any details needed for quality output, as needed ...",
  },
  "44": {
    subtitle:
      "Your intelligent agent for analyzing proposals and generating responses",
    promptTitle: "",
    inputPlaceholder:
      "Please upload the proposal documents and evaluation criteria.",
  },
  "45": {
    subtitle:
      "Your intelligent agent that captures sourcing details, generates an SOW, and creates an evaluation package",
    promptTitle: "",
    inputPlaceholder:
      "Describe your RFQ requirements to build the SOW and evaluation package (e.g., we need to procure a cloud-based CRM for Core42)",
  },
  "47": {
    subtitle:
      "Your intelligent agent for verifying contracts from a legal point of view",
    promptTitle: "",
    inputPlaceholder:
      "Upload your document for legal review and compliance check",
  },
  "26": {
    subtitle: "Your intelligent procurement assistant that produces:",
    promptTitle: "What would you like me to help you with today?",
    inputPlaceholder: "Type your message here...",
  },
  "48": {
    subtitle:
      "Your intelligent legal agent for drafting Non-Disclosure Agreements.",
    promptTitle: "What would you like to do today?",
    inputPlaceholder: "Describe your NDA needs",
  },
  "110": {
    subtitle: "Your intelligent agent for job intake before sourcing",
    promptTitle: "",
    inputPlaceholder: "Upload a job description to get started...",
  },
  "103": {
    subtitle: "",
    promptTitle: "",
    inputPlaceholder: "Upload contracts and provide transaction context",
  },
  "52": {
    subtitle: "",
    promptTitle: "",
    inputPlaceholder:
      "Upload older version and newer version to generate the redlined comparison",
  },
  "54": {
    subtitle:
      "Your intelligent legal agent for drafting Memorandum of Understanding documents.",
    promptTitle: "What MoU would you like to create today?",
    inputPlaceholder:
      "Describe your MoU needs (e.g., I want to create an MoU with XYZ Corp for a joint research collaboration)",
  },
  "55": {
    subtitle:
      "Intelligent role-to-skill benchmarking powered by taxonomy-driven Human Capital intelligence.",
    promptTitle:
      "What role or job description would you like to analyze today?",
    inputPlaceholder:
      "Upload a JD or describe the role to generate a structured skills and proficiency mapping",
  },
  "57": {
    subtitle:
      "Convert skill gap assessment results into personalized learning journeys, development objectives, and targeted training recommendations.",
    promptTitle:
      "Ready to turn your assessment results into a personalized learning plan?",
    inputPlaceholder:
      "Generate a personalized learning path based on the selected skill gap assessment, career goals, learning preferences, and development priorities",
  },
  "58": {
    subtitle:
      "Discover and compare training opportunities aligned to your selected learning path, skill development goals, and learning preferences.",
    promptTitle:
      "Ready to find the best training options for your learning journey?",
    inputPlaceholder:
      "Generate personalized course and training recommendations based on your selected learning path, preferred learning formats, budget, and development goals",
  },
  "59": {
    subtitle:
      "Intelligent talent sourcing powered by internal workforce intelligence, external talent networks, and role-specific skill matching.",
    promptTitle: "What role would you like to source candidates for today?",
    inputPlaceholder:
      "Upload an approved job description or describe the role to identify qualified candidates across internal and external talent pools",
  },
  "60": {
    subtitle:
      "Intelligent supplier discovery powered by sourcing requirements, supplier capabilities, and procurement intelligence.",
    promptTitle:
      "What sourcing requirement would you like to find suppliers for today?",
    inputPlaceholder:
      "Upload an RFQ scope document or provide a purchase requirement to identify and rank qualified suppliers",
  },
  "61": {
    subtitle:
      "Intelligent interview design powered by role requirements, candidate context, and competency-based hiring frameworks.",
    promptTitle:
      "What role or candidate would you like to prepare an interview for today?",
    inputPlaceholder:
      "Upload a job description, candidate profile, or interview context to generate a structured interview question pack",
  },
  "138": {
    subtitle:
      "Your AI-powered interview platform — manage jobs, candidates, and interview reports all in one place.",
    promptTitle: "How would you like to start?",
    inputPlaceholder: "Type your message here...",
  },
  "504": {
    subtitle: "Your intelligent agent for manpower cost estimation.",
    promptTitle: "",
    inputPlaceholder: "Type your message here...",
  },
};

// Default values
export const DEFAULT_AGENT_TEXT: AgentTextConfig = {
  subtitle: "",
  promptTitle: "",
  inputPlaceholder: "Type your message here...",
};

// Flow steps configuration for agent cards
export const AGENT_FLOW_STEPS: Record<
  string,
  Array<{ id: number; text: string }>
> = {
  "18": [
    { id: 1, text: "Maps role to core & future-ready skills " },
    { id: 2, text: "Screens resumes from uploads and internal G42 database" },
    {
      id: 3,
      text: "Filters by past feedback & role criteria",
    },
    { id: 4, text: "Evaluates fit for round 1 interview" },
    { id: 5, text: "Shortlists candidates, initiates emails" },
  ],
  "30": [
    {
      id: 1,
      text: "Maps role to core capability, governance & production readiness",
    },
    { id: 2, text: "Filters out human CVs and incomplete profiles" },
    {
      id: 3,
      text: "Evaluates against Role core requirements",
    },
    { id: 4, text: "Evaluates against enterprise level G42 standards" },
    { id: 5, text: "Summarizes final ratings and evaluation" },
  ],
  "7": [
    { id: 1, text: "Takes the input document or content" },
    { id: 2, text: "Understands the source and target language" },
    { id: 3, text: "Understands the translation context" },
    { id: 4, text: "Highlights areas for user review" },
    { id: 5, text: "Generates the translated output" },
  ],
  "106": [
    { id: 1, text: "Receives and validates content" },
    { id: 2, text: "Understands intent and context" },
    { id: 3, text: "Extracts key messages and themes" },
    { id: 4, text: "Adapts content per platform " },
    { id: 5, text: "Generates platform-ready social posts" },
  ],
  "20": [
    {
      id: 1,
      text: "Provides Business, Finance, Procurement, Legal review of contract proposal",
    },
    {
      id: 2,
      text: "Identifies deviations, key gaps and risks",
    },
    {
      id: 3,
      text: "Consolidates functional review inputs to prepare negotiation list",
    },
    { id: 4, text: "Redrafts clean contract copy post negotiation inputs" },
  ],
  "21": [
    { id: 1, text: "Intakes sourcing details from user" },
    {
      id: 2,
      text: "Selects business unit & category specific best practices template",
    },
    { id: 3, text: "Drafts contract templates from user input and proposals" },
    {
      id: 4,
      text: "Answers user questions related to SOW template",
    },
    {
      id: 5,
      text: "Drafts SOW template based on input proposal and selected template",
    },
  ],
  "46": [
    { id: 1, text: "Intakes contract file from user" },
    { id: 2, text: "Runs compliance scan against checklist" },
    { id: 3, text: "Highlights risks and deviations" },
    { id: 4, text: "Generates actionable smart recommendations" },
    { id: 5, text: "Produces final reviewed output" },
  ],
  "23": [
    { id: 1, text: "Receives job role as input" },
    { id: 2, text: "Analyzes the role requirements" },
    { id: 3, text: "Identifies required skills and qualifications" },
    { id: 4, text: "Creates comprehensive job description" },
  ],
  "24": [
    { id: 1, text: "Analyzes job role and requirements" },
    { id: 2, text: "Identifies core functional and technical skills" },
    { id: 3, text: "Maps future-ready skills" },
    { id: 4, text: "Establishes required qualifications" },
    { id: 5, text: "Generates preferred qualifications" },
  ],
  "25": [
    { id: 1, text: "Processes executive requests" },
    { id: 2, text: "Analyzes business intelligence" },
    { id: 3, text: "Prepares strategic insights" },
    { id: 4, text: "Coordinates office operations" },
    { id: 5, text: "Delivers executive summaries" },
  ],
  "31": [
    { id: 1, text: "Processes executive requests" },
    { id: 2, text: "Analyzes business intelligence" },
    { id: 3, text: "Prepares strategic insights" },
    { id: 4, text: "Coordinates office operations" },
    { id: 5, text: "Delivers executive summaries" },
  ],
  "32": [
    { id: 1, text: "Processes executive requests" },
    { id: 2, text: "Analyzes business intelligence" },
    { id: 3, text: "Prepares strategic insights" },
    { id: 4, text: "Coordinates office operations" },
    { id: 5, text: "Delivers executive summaries" },
  ],
  "33": [
    { id: 1, text: "Processes executive requests" },
    { id: 2, text: "Analyzes business intelligence" },
    { id: 3, text: "Prepares strategic insights" },
    { id: 4, text: "Coordinates office operations" },
    { id: 5, text: "Delivers executive summaries" },
  ],
  "1": [
    { id: 1, text: "Create press release" },
    { id: 2, text: "Translates to arabic" },
    { id: 3, text: "Creates media Q&A brief" },
  ],
  "44": [
    { id: 1, text: "Reviews and analyzes RFQ Response proposal document" },
    { id: 2, text: "Evaluates requirements and specifications" },
    { id: 3, text: "Assesses feasibility of proposed solution" },
    { id: 4, text: "Generates comprehensive response" },
    { id: 5, text: "Provides recommendations and next steps" },
  ],
  "45": [
    { id: 1, text: "Captures sourcing details from user" },
    { id: 2, text: "Collects project & goods/services requirements" },
    { id: 3, text: "Generates SOW draft using best-practice template" },
    { id: 4, text: "Generates and downloads final SOW PDF" },
    { id: 5, text: "Generates evaluation package for vendor assessment" },
  ],
  "47": [
    { id: 1, text: "Receives and analyzes contract document" },
    { id: 2, text: "Reviews legal clauses and terms" },
    { id: 3, text: "Checks regulatory compliance" },
    { id: 4, text: "Identifies legal risks and gaps" },
    { id: 5, text: "Provides legal recommendations" },
  ],
  "26": [
    { id: 1, text: "Intent classification" },
    { id: 2, text: "Query planner" },
    { id: 3, text: "SQL generator" },
    { id: 4, text: "Answering agent" },
  ],
  "48": [
    { id: 1, text: "Guides you through NDA creation step by step" },
    {
      id: 2,
      text: "Captures purpose and counterparty details for drafting",
    },
    { id: 3, text: "Selects the best-fit NDA template" },
    {
      id: 4,
      text: "Generates an editable G42-standard NDA draft for legal review",
    },
    {
      id: 5,
      text: "Reviews uploaded NDAs when you explicitly ask for a review",
    },
  ],
  "110": [
    { id: 1, text: "Extracts role details directly from JD" },
    { id: 2, text: "Identifies required skills and qualifications" },
    {
      id: 3,
      text: "Asks clarifying questions and makes intelligent suggestions",
    },
    {
      id: 4,
      text: "Compiles all relevant inputs for the recruiters to start sourcing",
    },
    { id: 5, text: "Produces a final, well-structured job intake document" },
  ],
  "103": [
    { id: 1, text: "Contract ingestion and validation" },
    { id: 2, text: "Content review and analysis" },
    {
      id: 3,
      text: "Change of Control trigger assessment",
    },
    {
      id: 4,
      text: "Action identification and risk evaluation",
    },
    { id: 5, text: "Final report generation" },
  ],
  "52": [
    {
      id: 1,
      text: "Identifies counterparties and locates latest contract versions",
    },
    {
      id: 2,
      text: "Retrieves documents across Outlook threads and SharePoint sources",
    },
    {
      id: 3,
      text: "Detects version gaps, conflicts and negotiation ambiguities",
    },
    {
      id: 4,
      text: "Generates clause-level professional Word redlines with track changes",
    },
    {
      id: 5,
      text: "Routes exceptions for human confirmation and final review",
    },
  ],
  "54": [
    {
      id: 1,
      text: "Collects counterparty, project, and collaboration details",
    },
    {
      id: 2,
      text: "Extracts structured fields and classifies MoU template type",
    },
    {
      id: 3,
      text: "Presents confirmation card for review and corrections",
    },
    {
      id: 4,
      text: "Generates complete MoU draft with G42 standard positions",
    },
    {
      id: 5,
      text: "Produces downloadable DOCX for legal sign-off",
    },
  ],
  "55": [
    {
      id: 1,
      text: "Understands Role & JD Context",
    },
    {
      id: 2,
      text: "Identifies Role Type & Benchmark Framework",
    },
    {
      id: 3,
      text: "Maps Skills Against Enterprise Taxonomy",
    },
    {
      id: 4,
      text: "Generates Benchmark Skills & Proficiency Levels",
    },
    {
      id: 5,
      text: "Refines & Finalizes Benchmark Outputs",
    },
  ],
  "57": [
    { id: 1, text: "Retrieves the selected skill gap assessment results" },
    { id: 2, text: "Identifies critical and prioritized skill gaps" },
    { id: 3, text: "Maps gaps to measurable learning objectives" },
    { id: 4, text: "Builds a personalized and sequenced development plan" },
    { id: 5, text: "Generates training recommendations and learning pathways" },
  ],
  "58": [
    {
      id: 1,
      text: "Receives selected learning path and development objectives",
    },
    {
      id: 2,
      text: "Analyzes learning preferences, budget, and delivery requirements",
    },
    {
      id: 3,
      text: "Identifies relevant courses, certifications, and learning resources",
    },
    {
      id: 4,
      text: "Ranks recommendations based on skill alignment and learner preferences",
    },
    {
      id: 5,
      text: "Generates a curated training plan for employee selection and finalization",
    },
  ],
  "59": [
    {
      id: 1,
      text: "Receives role requirements and sourcing priorities",
    },
    {
      id: 2,
      text: "Searches internal talent pools, alumni, and past applicants",
    },
    {
      id: 3,
      text: "Identifies external candidates using skill and experience signals",
    },
    {
      id: 4,
      text: "Ranks candidates based on fit, availability, and sourcing objectives",
    },
    {
      id: 5,
      text: "Generates a curated candidate pipeline and sourcing insights",
    },
  ],
  "60": [
    {
      id: 1,
      text: "Receives sourcing requirements from RFQ or purchase request",
    },
    {
      id: 2,
      text: "Analyzes supplier categories, capabilities, and scope requirements",
    },
    {
      id: 3,
      text: "Filters approved, active, and compliant suppliers",
    },
    {
      id: 4,
      text: "Ranks suppliers based on relevance, qualifications, and performance indicators",
    },
    {
      id: 5,
      text: "Generates a prioritized supplier recommendation list with rationale",
    },
  ],
  "61": [
    {
      id: 1,
      text: "Receives role requirements and candidate information",
    },
    {
      id: 2,
      text: "Analyzes competencies, interview stage, and pre-screening history",
    },
    {
      id: 3,
      text: "Generates role-specific technical and behavioral questions",
    },
    {
      id: 4,
      text: "Creates structured follow-up and probing questions",
    },
    {
      id: 5,
      text: "Produces a standardized interview question pack",
    },
  ],
  "504": [
    {
      id: 1,
      text: "Upload manpower requirement",
    },
    {
      id: 2,
      text: "Agent extracts and maps each role to the rate card",
    },
    {
      id: 3,
      text: "Calculates estimated lumpsum CTC or estimated CTC range for the project",
    },
    {
      id: 4,
      text: "Generates estimated cost",
    },
  ],
};

export const g42_companies = {
  analog_studios_fz_llc: "Analog Studios FZ LLC",
  core42_holdings_us_llc: "Core42 Holdings US LLC",
  core42_technology_projects_llc: "Core42 Technology Projects LLC",
  ct_corporate_services_llc: "CT Corporate Services LLC",
  daypop_technology_projects_llc: "DayPop Technology Projects LLC",
  g_forty_two_general_trading_llc: "G Forty Two General Trading LLC",
  g42_cloud_technology_llc: "G42 Cloud Technology LLC",
  g42_india_technology_private_limited: "G42 India Technology Private Limited",
  g42_international_holding_rsc_ltd: "G42 International Holding RSC Ltd",
  g42_sky20_technological_projects_llc:
    "G42 Sky20 Technological Projects L.L.C.",
  g42_sky21_technological_projects_llc: "G42 Sky21 Technological Projects LLC",
  g42_sky7_technological_projects_llc: "G42 SKY7 TECHNOLOGICAL PROJECTS L.L.C.",
  group_42_uk_limited: "Group 42 UK Limited",
  i42_us_dc_holding_llc: "I42 US DC holding LLC",
  inception_ai_investments_ltd: "Inception AI Investments Ltd",
  inception_ai_ip_ltd: "Inception AI IP Ltd",
  inception_ai_r_and_d_fz_llc: "INCEPTION AI R AND D FZ LLC",
  inception_artificial_intelligence_llc_opc:
    "Inception Artificial Intelligence LLC OPC",
  inception_holding_rsc_ltd: "INCEPTION HOLDING RSC LTD",
  inception_institute_of_artificial_intelligence_ltd:
    "INCEPTION INSTITUTE OF ARTIFICIAL INTELLIGENCE LTD",
  injazat_data_systems_llc: "Injazat Data Systems LLC",
};

export const g42_entities = {
  "1070_inception_ai_investments_ltd": "1070-Inception AI Investments Ltd",
  "42a_us_holding_llc": "42A US Holding LLC",
  analog_artificial_intelligence_llc_spc:
    "Analog Artificial Intelligence-L.L.C-S.P.C",
  analog_studios_fz_llc: "Analog Studios FZ LLC",
  core42_fz_llc: "Core42 FZ LLC",
  core42_holding_rsc_ltd: "Core42 Holding RSC Ltd",
  core42_holding_us_llc: "Core42 Holding US LLC",
  core42_technology_projects_llc: "Core42 Technology Projects LLC",
  cpx_holding_llc_opc: "CPX Holding – L.L.C. – O.P.C",
  ct_corporate_services_llc: "CT Corporate Services LLC",
  daypop_technology_projects_llc: "DayPop Technology Projects LLC",
  expansion_project_technologies_holding_11_spv_rsc_ltd:
    "Expansion Project Technologies Holding 11 SPV RSC Ltd",
  g_forty_two_general_trading_llc: "G Forty Two General Trading - LLC",
  g42_capital_limited: "G42 CAPITAL LIMITED",
  g42_cloud_technology_llc: "G42 Cloud Technology LLC",
  g42_communications_llc: "G42 Communications LLC",
  g42_companies_management_limited: "G42 Companies Management Limited",
  g42_infrastructure_ai_holding_rsc_ltd:
    "G42 Infrastructure AI Holding RSC Ltd",
  g42_pharmaceutical_manufacturing_llc: "G42 Pharmaceutical Manufacturing LLC",
  g42_sky21_technological_projects_llc: "G42 Sky21 Technological Projects LLC",
  g42_sky7_technological_projects_llc: "G42 Sky7 Technological Projects LLC",
  global_valley_technological_projects_sole_proprietorship_llc:
    "Global Valley Technological Projects - Sole Proprietorship LLC",
  group_42_holding_ltd: "Group 42 Holding Ltd",
  gx_investments_us_llc: "GX Investments US LLC",
  hassantuk: "Hassantuk",
  i42_us_dc_holding_llc: "I42 US DC Holding LLC",
  inception_ai_investments_ltd: "Inception AI Investments Ltd",
  inception_ai_r_and_d_fz_llc: "Inception AI R and D FZ LLC",
  inception_artificial_intelligence_llc_opc:
    "Inception Artificial Intelligence LLC OPC",
  inception_holding_rsc_ltd: "Inception Holding RSC Ltd",
  inception_institute_of_artificial_intelligence_ltd:
    "Inception Institute of Artificial Intelligence Ltd",
  injazat_data_systems_llc: "Injazat Data Systems LLC",
  makhzan1_technologies_llc_spc: "Makhzan1 Technologies LLC SPC",
  mozn_holding_limited: "MOZN Holding Limited",
  pivot_asset_holding_rsc_ltd: "Pivot Asset Holding RSC Ltd",
  tsi_middle_east_information_technology_solutions_llc:
    "TSI Middle East Information Technology Solutions LLC",
};

export const g42_contract_owner = {
  adele_herlihy: "Adele Herlihy",
  adrian_hobbs: "Adrian Hobbs",
  aislinn_barr: "Aislinn Barr",
  alfred_alava: "Alfred Alava",
  ali_jibran: "Ali Jibran",
  amy_lehoczky: "Amy Lehoczky",
  andrew_chacko: "Andrew Chacko",
  anni_gupta: "Anni Gupta",
  ashish_ramsurrun: "Ashish Ramsurrun",
  bhavuk_arora: "Bhavuk Arora",
  bonnie_wortha: "Bonnie Wortha",
  bradley_worrall: "Bradley Worrall",
  chandni_javeri: "Chandni Javeri",
  coco_jin: "Coco Jin",
  danish_kadiri: "Danish Kadiri",
  david_power: "David Power",
  dilip_vyas: "Dilip Vyas",
  divyesh_mahajan: "Divyesh Mahajan",
  dr_mike_roshchin: "Dr. Mike Roshchin",
  elmer_barboza: "Elmer Barboza",
  farrukh_zaheer: "Farrukh Zaheer",
  firas_khair: "Firas Khair",
  grzegorz_kosior: "Grzegorz Kosior",
  hatem_saber: "Hatem Saber",
  ignasi_ferrer_gomez: "Ignasi Ferrer Gomez",
  jafeen_jamaludeen: "Jafeen Jamaludeen",
  jaydeep_pandat: "Jaydeep Pandat",
  joanne_norman: "Joanne Norman",
  john_franklin: "John Franklin",
  kathleen_meneses: "Kathleen Meneses",
  lauren_phillips: "Lauren Phillips",
  louella_thomas: "Louella Thomas",
  lubna_zegabrah: "lubna Zegabrah",
  lucy_browne: "Lucy Browne",
  maria_rogacion: "Maria Rogacion",
  maxim_zhurbin: "Maxim Zhurbin",
  mothasim_kozhipurath: "Mothasim Kozhipurath",
  needhish_kuruvilla: "Needhish Kuruvilla",
  neha_verma: "Neha Verma",
  niall_o_broin: "Niall Ó Broin",
  noaf_moussa: "Noaf Moussa",
  paulo_mata: "Paulo Mata",
  petro_elmelegey: "Petro Elmelegey",
  poojitha_lokanath: "Poojitha Lokanath",
  rajinder_kanda: "Rajinder Kanda",
  rasha_guirguis: "Rasha Guirguis",
  rohit_manucha: "Rohit Manucha",
  sedef_demircan: "Sedef Demircan",
  shabeerali_kunhiriam: "Shabeerali Kunhiriam",
  sheba_abraham: "Sheba Abraham",
  shiju_badarudeen: "Shiju Badarudeen",
  shubhanshi_gupta: "Shubhanshi Gupta",
  sian_warren: "Sian Warren",
  tarun_gupta: "Tarun Gupta",
  taybah_alameri: "Taybah Alameri",
  tina_mohandas: "Tina Mohandas",
};

/**
 * Configuration for MessageInput visibility control
 * Defines rules for when to hide/show the message input field for specific agents
 */
export type MessageInputVisibilityRule = {
  agentId: string;
  hideWhen: "hasMessages" | "noMessages";
  description?: string;
};

/**
 * Array of rules defining when to hide MessageInput for specific agents
 *
 * Usage patterns:
 * - hideWhen: "hasMessages" - Hide input AFTER messages exist (e.g., RFQ Builder dynamic forms)
 * - hideWhen: "noMessages" - Hide input BEFORE messages exist (e.g., Custom initial UI components)
 *
 * @example
 * // Agent 45 (RFQ Builder): Hide input after first message is sent
 * { agentId: "45", hideWhen: "hasMessages" }
 *
 * // Agent 57 (Learning Path): Hide input during initial state with custom UI
 * { agentId: "57", hideWhen: "noMessages" }
 */
export const MESSAGE_INPUT_VISIBILITY_RULES: MessageInputVisibilityRule[] = [
  {
    agentId: "45",
    hideWhen: "hasMessages",
    description: "RFQ Builder - Hide input after dynamic form loads",
  },
  {
    agentId: "57",
    hideWhen: "noMessages",
    description:
      "Learning Path - Hide input during initial LearningPathButton state",
  },
  {
    agentId: "58",
    hideWhen: "noMessages",
    description:
      "Training Search - Hide input during initial TrainingSearchButton state",
  },
  {
    agentId: "61",
    hideWhen: "noMessages",
    description:
      "Interview Pack - Hide input during initial InterviewPackButton state",
  },
  {
    agentId: "504",
    hideWhen: "noMessages",
    description:
      "Manpower Cost Calculator - Hide input during initial ManpowerCostForm state",
  },
];

/**
 * Determines if the MessageInput should be hidden based on agent configuration
 *
 * @param agentId - The current agent ID
 * @param hasMessages - Whether the chat has any messages
 * @returns boolean - True if input should be hidden, false otherwise
 *
 * @example
 * const shouldHide = shouldHideMessageInput("57", false);
 * // Returns true for agent 57 with no messages
 *
 * const shouldHide = shouldHideMessageInput("45", true);
 * // Returns true for agent 45 with messages
 */
export const shouldHideMessageInput = (
  agentId: string | undefined,
  hasMessages: boolean,
): boolean => {
  if (!agentId) return false;

  const rule = MESSAGE_INPUT_VISIBILITY_RULES.find(
    (r) => r.agentId === agentId,
  );

  if (!rule) return false;

  return rule.hideWhen === "hasMessages" ? hasMessages : !hasMessages;
};
